export const Options = {
    PreferredLocation: [
        { text:"Osnabrück",value:"1"},
        { text:"Melle",value:"2"},
        { text:"Papenburg",value:"3"},
        { text:"Meppen",value:"4"},
        { text:"Herford", value:"5"},
        { text:"Bad Essen",value:"6"},
    ],
    BecomingAwareThrough: [
        { text:"Agentur für Arbeit", value:"Agentur für Arbeit"},
        { text:"AUBIPlus", value:"AUBIPlus"},
        { text:"Ausbildungsplätze fertig los", value:"Ausbildungsplätze fertig los"},
        { text:"Facebook", value:"Facebook"},
        { text:"Google Jobs", value:"Google Jobs"},
        { text:"Indeed", value:"Indeed"},
        { text:"Instagram", value:"Instagram"},
        { text:"Jobware", value:"Jobware"},
        { text:"Kleinanzeigen", value:"Kleinanzeigen"},
        { text:"Kununu", value:"Kununu"},
        { text:"LinkedIn", value:"LinkedIn"},
        { text:"Messe", value:"Messe"},
        { text:"Monster", value:"Monster"},
        { text:"Persönliche Empfehlung", value:"Persönliche Empfehlung"},
        { text:"PKF WMS Event", value:"PKF WMS Event"},
        { text:"Schule / Hochschule", value:"Schule / Hochschule"},
        { text:"Stellenzeigen.de", value:"Stellenzeigen.de"},
        { text:"StepStone", value:"StepStone"},
        { text:"TikTok", value:"TikTok"},
        { text:"Unternehmenswebsite www.pkf-wms.de", value:"Unternehmenswebsite www.pkf-wms.de"},
        { text:"Xing Jobs", value:"Xing Jobs"},
        { text:"YouTube", value:"YouTube"},
        { text:"Sonstiges", value:"Sonstiges"},
    ]
}
